import * as React from "react";
import { IOWidget, mk_pair, mk_widget, Pair } from "../widget";

interface BothProps<i,o1,o2> {
  input:i
  widget1:IOWidget<i,o1>
  widget2:IOWidget<i,o2>
  on_done_both:(outputs:Pair<o1,o2>) => void
}

interface BothState<_i,o1,o2> {
  value1:o1 | null
  value2:o2 | null
}

/** @deprecated Don't use directly, use the [[both]] function instead.
*/
class Both<i,o1,o2> extends React.Component<BothProps<i,o1,o2>, BothState<i,o1,o2>> {
  constructor(props:BothProps<i,o1,o2>, context:any) {
    super(props, context)

    this.state = { value1:null, value2:null }
  }

  render() {
    return <>
      {this.props.widget1(this.props.input).run(new_value =>
        this.setState(s => ({...s, value1:new_value}),
        () => this.state.value1 && this.state.value2 ? this.props.on_done_both(mk_pair(this.state.value1, this.state.value2)) : null))}
      {this.props.widget2(this.props.input).run(new_value =>
          this.setState(s => ({...s, value2:new_value}),
          () => this.state.value1 && this.state.value2 ? this.props.on_done_both(mk_pair(this.state.value1, this.state.value2)) : null))}
      </>
  }
}

/*
  Both have to fire.
  Used instead of `all` in cases the output types differ. It saves you a map.
 */
export const both = function<i,o1,o2>(widget1:IOWidget<i,o1>, widget2:IOWidget<i,o2>) :
  IOWidget<i,Pair<o1,o2>> {
  return (input:i) => mk_widget({
    run:(on_done_both:(outputs:Pair<o1,o2>) => void) =>
      React.createElement<BothProps<i,o1,o2>>(Both, { on_done_both, widget1, widget2, input })
  })
}
